export const projects = [
  {
    id: 1,
    title: "Portfolio Website",
    description: "A fully responsive personal portfolio built using React and Tailwind CSS.",
    tech: ["React", "Tailwind"],
    image: "https://images.unsplash.com/photo-1558655146-9f40138edfeb?w=1200",
    link: "https://strong-begonia-5b30bd.netlify.app/",
    github: "https://github.com/vermarishika24598-blip/shiny-succotash",
  },

  {
    id: 2,
    title: "Movie Explorer",
    description: "A movie browsing app with search, filters, and dynamic UI.",
    tech: ["React", "Tailwind"],
    image: "https://images.unsplash.com/photo-1594909122845-11baa439b7bf?w=1200",
    link: "https://classy-centaur-c06c62.netlify.app/",
    github: "https://github.com/vermarishika24598-blip/react-movie-explorer",
  },

  {
    id: 3,
    title: "E-Commerce Website",
    description: "A complete e-commerce app with cart, filters, and Redux state management.",
    tech: ["React", "Tailwind", "Redux"],
    image: "https://images.unsplash.com/photo-1557821552-17105176677c?w=1200",
    link: "#",
    github: "#",
  }
];
